import { Charts } from './Charts';
import CurrentPregnancyChartsDataProvider from './contexts/CurrentPregnancyChartsDataContext';

const CurrentPregnancyWrapper = () => {
    return (
        <CurrentPregnancyChartsDataProvider>
            <Charts />
        </CurrentPregnancyChartsDataProvider>
    );
};

export default CurrentPregnancyWrapper;
